import { Space } from 'antd';
import { type ReactNode } from 'react';
import styled from 'styled-components';

export interface ICardOptionContentProps {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  note?: ReactNode;
}

const CardOptionContentWrapper = styled.div`
  font-size: 16px;
  line-height: 1.2em;
`;

const CardOptionContentTitle = styled.span`
  font-weight: 600;
`;

const CardOptionContentSubtitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colorTextSecondary};
  margin-left: 6px;
`;

const CardOptionContentDescription = styled.div`
  font-size: 14px;
  margin-top: 4px;
  line-height: 1.3em;
  color: ${({ theme }) => theme.colorTextSecondary};
`;

const CardOptionContentNote = styled.div`
  margin-top: 8px;
`;

const CardOptionContentIcon = styled.span`
  color: ${({ theme }) => theme.colorPrimary};
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

/**
 * Contenuto standard per una card opzione di RadioCardGroup / CheckboxCardGroup.
 * Compone icona, titolo, sottotitolo inline (es. "Default"), descrizione e nota
 * a piè di card (es. tag).
 */
export function CardOptionContent(props: Readonly<ICardOptionContentProps>) {
  const { icon, title, subtitle, description, note } = props;
  return (
    <CardOptionContentWrapper>
      <Space>
        {icon && <CardOptionContentIcon>{icon}</CardOptionContentIcon>}
        <CardOptionContentTitle>{title}</CardOptionContentTitle>
        {subtitle && (
          <CardOptionContentSubtitle>{subtitle}</CardOptionContentSubtitle>
        )}
      </Space>
      {description && (
        <CardOptionContentDescription>
          {description}
        </CardOptionContentDescription>
      )}
      {note && <CardOptionContentNote>{note}</CardOptionContentNote>}
    </CardOptionContentWrapper>
  );
}
